// **** import modules ****
import app, { csl, u_, vuwer } from "@@assets/scripts/common";
import "./_auth";
import "./_download";

// **** process ****
app.gaAutoSendPageview = false;

app.onReady((...args) => {
	csl.log.orange(`${app.pageName} onReady`, ...args);
});

vuwer.setProp({
	async onChangeState(state) {
		csl.log.red("vuwer.changeState", state);
		
		const flg = {
			popstate: !!state.popstate
		};
		delete state.popstate;
		
		const methods = [];
		
		const { downloads } = this;
		if( Array.isArray(downloads) ) {
			state.auth = 1;
			methods.push(
				vuwer.get("downloadSection").setState({ list: downloads })
			);
		} else
		if( u_.hasProperty(state, "auth") ) {
			delete state.auth;
		}
		
		vuwer.get("body").$self.attr("data-auth", !state.auth ? "0" : "1");
		
		//// history change ////
		const hstry = (!app.isReady || flg.popstate) ? "replaceState" : "pushState";
		app[hstry](state);
		
		if(methods.length) {
			await Promise.all(methods);
		}
	}
})

app.exec();
